export default "__VITE_ASSET__Cvpqo78G__"